module.exports = __webpack_public_path__ + "r-v3/img/ml_08_00_over.8bef9ca1.jpg";